// components/LanguageSwitcher.js
import React from "react";

export default function LanguageSwitcher({ selectedLanguage, onChange }) {
  return (
    <div className="arh-flex arh-h-[2.813rem] arh-w-[7.812rem] arh-items-center arh-rounded-lg arh-bg-[#F5F5F5] arh-p-1">
      <div
        className={`transition-all arh-flex arh-h-full arh-w-1/2 arh-cursor-pointer arh-items-center arh-justify-center arh-rounded-lg arh-font-poppins arh-text-[0.875rem] arh-font-medium ${
          selectedLanguage === "FR"
            ? "arh-bg-white arh-text-black"
            : "arh-text-[#3C3C4399]"
        }`}
        onClick={() => onChange("FR")}
      >
        FR
      </div>
      <div
        className={`transition-all arh-flex arh-h-full arh-w-1/2 arh-cursor-pointer arh-items-center arh-justify-center arh-rounded-lg arh-font-poppins arh-text-[0.875rem] arh-font-medium ${
          selectedLanguage === "EN"
            ? "arh-bg-white arh-text-black"
            : "arh-text-[#3C3C4399]"
        }`}
        onClick={() => onChange("EN")}
      >
        EN
      </div>
    </div>
  );
}
